import HonorsInfoContent from './HonorsInfoContent';

export default HonorsInfoContent;
